import React, { useState, useEffect, useContext } from "react";
import Table from "./Table";
import { AuthContext } from '../../context/AuthContext';
import {createGlobalStyle} from "styled-components"
import Calendar from 'rc-year-calendar';
import 'rc-year-calendar/locales/rc-year-calendar.es';
import { getVacationsHistory, requestVacations, getVacationsSummary } from "../../services/VacationHistoryService";
import { getLabourerDays, getBankHolidays } from "../../services/BankHolidaysService";
import { Button, Modal, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { VacationsContext } from '../../context/VacationsContext';

const CalendarStyle = createGlobalStyle`
  .calendar {
    overflow-x: visible !important;
  }
  .calendar .months-container .month-container {
    margin-bottom: 1%;
  }
`

const Vacations = () => {

    const { userId } = useContext(AuthContext);
    const [updateCalendar, setUpdateCalendar] = useState('');

    const updateCalendarParent = (update) => {
        setUpdateCalendar(update);
    };

    const contextValue = {
        updateParent: updateCalendar,
        setUpdateParent: updateCalendarParent
    };
    
    const [dataSource, setDataSource] = useState([]);
    const [year, setYear] = useState(new Date().getFullYear());
    const currentYear = new Date().getFullYear();
    let [startDate, setStartDate] = useState([]);
    let [endDate, setEndDate] = useState([]);
    let [laborerDays, setLaborerDays] = useState([]);
    let [pendingDays, setPendingDays] = useState();
    let [approvedDays, setApprovedDays] = useState();
    let [availableDays, setAvailableDays] = useState();
    const [show, setShow] = useState(false);

    const [showError, setShowError] = useState(false);
    const handleCloseError = () => setShowError(false);
    const handleShowError = () => setShowError(true);

    const [showDuplicateError, setShowDuplicateError] = useState(false);
    const handleCloseDuplicateError = () => setShowDuplicateError(false);
    const handleShowDuplicateError = () => setShowDuplicateError(true);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const getSummary = async () => {
        const data = await getVacationsSummary(userId, year);
        setPendingDays(data.pending_days);
        setApprovedDays(data.approved_days);
        setAvailableDays(data.total_days);
    }

    const setDates = async (s, e) => {
        const offset = s.getTimezoneOffset();
        s = new Date(s.getTime() - (offset*60*1000));
        e = new Date(e.getTime() - (offset*60*1000));
        let start_date = s.toISOString().split('T')[0];
        let end_date = e.toISOString().split('T')[0];
        let l = await getTotalDays(start_date, end_date);
        setStartDate(start_date);
        setEndDate(end_date);
        setLaborerDays(l);
    }

    const handleSubmit = async () => {

        let today = new Date();

        let formData = {
            user_id: userId,
            start_date: startDate,
            end_date: endDate,
            total_days: laborerDays,
            year: year.toString(),
            request_date: today.toLocaleString("es-ES", {timeZone: "Europe/Madrid"})
        }

        const response = await requestVacations(JSON.stringify(formData));
        if(response === undefined){
            handleClose();
            handleShowError();
        } else {
            if(response.status === 400) {
                handleClose();
                handleShowError();
            } else if(response.status === 200 && response.data.user_id === 'None'){
                handleClose();
                handleShowDuplicateError();
            } else if(response.data.total_days === 0){
                handleClose();
            } else {
                setUpdateCalendar(Math.random());
                setShow(false);
            }
        } 
    }

    const getVacations = async (userId) => {
        let color;
        let disabled;
        let data = [];
        let res = await getVacationsHistory(userId, year, false);
        for (const key in res) {
            if (res[key].status === "APPROVED" || res[key].status === "PENDING") {
                if (res[key].status === "PENDING") {
                    color = "#ffd500";
                    disabled = true;
                } else if (res[key].status === "APPROVED") {
                    color = "#009134FF";
                    disabled = true;
                }

                data.push({
                    name: "Vacaciones",
                    startDate: new Date(res[key].start_date),
                    endDate: new Date(res[key].end_date),
                    color: color,
                    disabled: disabled
                })
            }
        }
    
        res = await getBankHolidays(year);
        for (const key in res) {
                data.push({
                name: res[key].name,
                startDate: new Date(res[key].date),
                endDate: new Date(res[key].date),
                color: "#dc3545"
            })
        }
        return data;
    }
    
    const getTotalDays = async (startDate, endDate) => {
        let res = await getLabourerDays(startDate, endDate);
        return res.days;
    }

    const yearChange = async (e) => {
        setYear(e.currentYear);
    }
    
    useEffect(() => {
        getVacations(userId).then((data) => {
            setDataSource(data);
        })
        getSummary();
    }, [updateCalendar, year])

    return (
        <div className="container">
            <div className="row align-items-center my-5">
                <div>
                    <Alert variant="danger" show={showDuplicateError} onClose={handleCloseDuplicateError} dismissible>
                        <Alert.Heading>Error!</Alert.Heading>
                        <p>
                        Selecciona días que no hayan sido previamente solicitados.
                        </p>
                    </Alert>
                    <Alert variant="danger" show={showError} onClose={handleCloseError} dismissible>
                        <Alert.Heading>Error!</Alert.Heading>
                        <p>
                        Días de vacaciones insuficientes.
                        </p>
                    </Alert>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-9" data-testid="calendar">
                                <Calendar
                                    style="background"
                                    language="es"
                                    weekStart={1}
                                    enableContextMenu={true}
                                    enableRangeSelection={true}
                                    disabledWeekDays={[0,6]}
                                    minDate={new Date((currentYear-2).toString()+"-01-01")}
                                    maxDate={new Date((currentYear+1).toString()+"-12-31")}
                                    dataSource={dataSource}
                                    onRangeSelected={e => {
                                        setDates(e.startDate,e.endDate);
                                        handleShow();
                                    }}
                                    onYearChanged={(e) => yearChange(e)}
                                />
                            </div>
                            <div className="col-md-3" data-testid="summary">
                                <div className="list-group">
                                    <div className="list-group-item justify-content-between">
                                        Días disponibles <span className="badge badge-primary badge-pill" data-testid="availableDays">{availableDays}</span>
                                    </div> 
                                    <div className="list-group-item justify-content-between">
                                        Días aprobados <span className="badge badge-success badge-pill" data-testid="approvedDays">{approvedDays}</span>
                                    </div> 
                                    <div className="list-group-item justify-content-between">
                                        Días pendientes <span className="badge badge-warning badge-pill" data-testid="pendingDays">{pendingDays}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        
                    <Modal show={show} onHide={handleClose}>
                        <div>
                            <Modal.Header closeButton>
                            <Modal.Title>Pedir vacaciones</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                            <form className="form-horizontal">
                                <div className="form-group row">
                                <label htmlFor="min-date" className="col-sm-2 control-label">Fecha</label>
                                <div className="col-sm-10">
                                    <div className="input-group input-daterange">
                                    <input type="string" id="startDate" name="startDate" className="form-control" value={startDate} disabled/>
                                    <div className="input-group-prepend input-group-append">
                                        <div className="input-group-text">a</div>
                                    </div>
                                    <input type="string" id="endDate" name="endDate" className="form-control" value={endDate} disabled/>
                                    </div>
                                </div>
                                </div>
                            </form>
                            </Modal.Body>

                            <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
                            <Button variant="primary" onClick={() => handleSubmit()}>Pedir días</Button>
                            </Modal.Footer>
                        </div>
                    </Modal>
                    <CalendarStyle />
                    <div>
                        <div>
                            <h4>Histórico</h4>
                        </div>
                        <VacationsContext.Provider value={contextValue}>
                            <Table year={year}/>
                        </VacationsContext.Provider>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Vacations;